import React from 'react';
import { bemClasses } from '../helpers';
export var Markdown = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: bemClasses.element("markdown") }, children));
};
//# sourceMappingURL=Markdown.js.map